// Pie de página unificado para todo el sitio.
// Reemplaza los dos footers anteriores (FooterContent.js y footer-data.js) en uno solo.
//
// Acepta una prop "variant" para mostrar las redes sociales correctas según el contexto:
//   - "data"      → muestra LinkedIn (para páginas técnicas / análisis de datos)
//   - "lifestyle" → muestra Instagram y TikTok (para teatro y perfumería)

import React from 'react';
import { FaLinkedin, FaInstagram, FaTiktok } from 'react-icons/fa';
import './footer.css';

// Renderiza el footer con íconos de redes según la variante recibida
const Footer = ({ variant = 'data' }) => {
  return (
    <footer className="site-footer">
      <div className="footer-content">

        <div className="footer-social">
          {variant === 'data' ? (
            // Páginas técnicas: solo LinkedIn
            <a
              href="https://www.linkedin.com/in/cagliero/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn de Matias Cagliero"
            >
              <FaLinkedin />
            </a>
          ) : (
            // Páginas de estilo de vida: Instagram y TikTok
            <>
              <a
                href="https://www.instagram.com/matias_cagliero/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram de Matias Cagliero"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.tiktok.com/@matias_cagliero"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok de Matias Cagliero"
              >
                <FaTiktok />
              </a>
            </>
          )}
        </div>

        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} Propiedad de Matias Cagliero. Todos los derechos reservados.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
